import React from 'react'
import styled from 'styled-components'
import Grid from '@mui/material/Grid'
import { useDispatch } from 'react-redux'

import { SearchInput } from './SearchInput'
import { resetPage, setSearchString } from 'redux/slices/TextAnalysis'
import { fetchContributions } from 'redux/thunks/TextAnalysis'
import { parseSearch } from './ParseSearch'
import { BulkSelectCheckbox } from './BulkSelectCheckbox'
import BulkAddTag from './BulkAddTag'

const StyledGrid = styled(Grid)`
  display: flex;
  align-items: center;
  background: white;
  margin: 1rem 0 !important;
  padding-right: 1.5rem;
  border-radius: 0.75rem;
  height: 3.375rem;

  @media only screen and (max-width: 700px) {
    background: transparent;
    padding: 0;
  }
`

const FlexSpacer = styled.div`
  flex-grow: 1;
`

const TagSearchAnalyzer = () => {
  const dispatch = useDispatch()

  const onSearch = (value: string) => {
    dispatch(resetPage())
    dispatch(setSearchString(parseSearch(value)))
    dispatch(fetchContributions())
  }

  return (
    <StyledGrid item xs={12} data-testid="ta-tag-search-analyser">
      <BulkSelectCheckbox />
      <BulkAddTag />
      <FlexSpacer />
      <SearchInput onSearch={onSearch} />
    </StyledGrid>
  )
}

export default React.memo(TagSearchAnalyzer)
